import { render } from "./ComposeEmail.vue?vue&type=template&id=c1072b68&scoped=true"
import script from "./ComposeEmail.vue?vue&type=script&lang=js"
export * from "./ComposeEmail.vue?vue&type=script&lang=js"

import "./ComposeEmail.vue?vue&type=style&index=0&id=c1072b68&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1072b68"]])

export default __exports__